export const Footer = () => {
    return (
        <div className="footer">
            <div className="">
                <a href="https://linkedin.com/company/superskyapps" target="_blank">LinkedIn</a>
                <a href="https://instagram.com/superskyapps" target="_blank">Instagram</a>
            </div>
        </div>
    )
}